import { useTranslation } from 'react-i18next';
import Section from "./Section";

const PolitiqueDeConfidentialite = () => {
  const { t } = useTranslation();

  return(
    <Section title={t('legal.privacy.title')} subtitle={t('legal.privacy.subtitle')}>
      <h2>{t('legal.privacy.purpose.title')}</h2>
      <p>{t('legal.privacy.purpose.intro')}
      <ol>
        <li>{t('legal.privacy.purpose.item1')}</li>
        <li>{t('legal.privacy.purpose.item2')}</li>
        <li>{t('legal.privacy.purpose.item3')}</li>
        <li>{t('legal.privacy.purpose.item4')}</li>
        <li>{t('legal.privacy.purpose.item5')}</li>
      </ol>
      </p>
      <p>{t('legal.privacy.purpose.disclaimer')}
      </p>
      <h2>{t('legal.privacy.applicableLaws.title')}</h2>
      <p>{t('legal.privacy.applicableLaws.intro')}
      <ol>
        <li>{t('legal.privacy.applicableLaws.item1')}</li>
        <li>{t('legal.privacy.applicableLaws.item2')}</li>
        <li>{t('legal.privacy.applicableLaws.item3')}</li>
        <li>{t('legal.privacy.applicableLaws.item4')}</li>
        <li>{t('legal.privacy.applicableLaws.item5')}</li>
        <li>{t('legal.privacy.applicableLaws.item6')}</li>
      </ol>
        {t('legal.privacy.applicableLaws.lawfulProcessing')}
        <ol>
          <li>{t('legal.privacy.applicableLaws.lawfulItem1')}</li>
          <li>{t('legal.privacy.applicableLaws.lawfulItem2')}</li>
          <li>{t('legal.privacy.applicableLaws.lawfulItem3')}</li>
          <li>{t('legal.privacy.applicableLaws.lawfulItem4')}</li>
          <li>{t('legal.privacy.applicableLaws.lawfulItem5')}</li>
          <li>{t('legal.privacy.applicableLaws.lawfulItem6')}</li>
        </ol>
      </p>
      <p>{t('legal.privacy.applicableLaws.ccpa')}
      </p>
      <h2>{t('legal.privacy.consent.title')}</h2>
      <p>
        {t('legal.privacy.consent.intro')}
      </p>
      <ol>
        <li>{t('legal.privacy.consent.item1')}</li>
        <li>{t('legal.privacy.consent.item2')}</li>
      </ol>
      <h2>{t('legal.privacy.dataCollection.title')}</h2>
      <h3>{t('legal.privacy.dataCollection.automaticTitle')}</h3>
      <p>{t('legal.privacy.dataCollection.automaticContent')}
      </p>
      <h3>{t('legal.privacy.dataCollection.nonAutomaticTitle')}</h3>
      <p>{t('legal.privacy.dataCollection.nonAutomaticContent')}
      </p>
      <p>{t('legal.privacy.dataCollection.disclaimer')}
      </p>
      <h2>{t('legal.privacy.dataUsage.title')}</h2>
      <p>{t('legal.privacy.dataUsage.intro')}
      </p>
      <p>{t('legal.privacy.dataUsage.automaticIntro')}
      </p>
      <ol>
        <li>{t('legal.privacy.dataUsage.item1')}</li>
        <li>{t('legal.privacy.dataUsage.item2')}</li>
      </ol>
      <h2>{t('legal.privacy.dataSharing.title')}</h2>
      <p>{t('legal.privacy.dataSharing.content')}</p>
      <h2>{t('legal.privacy.otherDisclosures.title')}</h2>
      <p>{t('legal.privacy.otherDisclosures.intro')}
      </p>
      <ol>
        <li>{t('legal.privacy.otherDisclosures.item1')}</li>
        <li>{t('legal.privacy.otherDisclosures.item2')}</li>
        <li>{t('legal.privacy.otherDisclosures.item3')}</li>
      </ol>
      <p>{t('legal.privacy.otherDisclosures.hyperlinks')}
      </p>
      <h2>{t('legal.privacy.dataRetention.title')}</h2>
      <p>{t('legal.privacy.dataRetention.content')}
      </p>
      <h2>{t('legal.privacy.dataProtection.title')}</h2>
      <p>{t('legal.privacy.dataProtection.content')}
      </p>
      <h2>{t('legal.privacy.minors.title')}</h2>
      <p>{t('legal.privacy.minors.content')}
      </p>
      <h2>{t('legal.privacy.userRights.title')}</h2>
      <p>{t('legal.privacy.userRights.intro')}
      </p>
      <ol>
        <li>{t('legal.privacy.userRights.item1')}</li>
        <li>{t('legal.privacy.userRights.item2')}</li>
        <li>{t('legal.privacy.userRights.item3')}</li>
        <li>{t('legal.privacy.userRights.item4')}</li>
        <li>{t('legal.privacy.userRights.item5')}</li>
        <li>{t('legal.privacy.userRights.item6')}</li>
      </ol>
      <p>{t('legal.privacy.userRights.moreInfo')}
      </p>
      <h2>{t('legal.privacy.dataModification.title')}</h2>
      <p>{t('legal.privacy.dataModification.content')}
      </p>
      <h2>{t('legal.privacy.cookies.title')}</h2>
      <p>{t('legal.privacy.cookies.intro')}
      </p>
      <p>{t('legal.privacy.cookies.usage')}
      </p>
      <p>{t('legal.privacy.cookies.settings')}
      </p>
      <h2>{t('legal.privacy.modifications.title')}</h2>
      <p>{t('legal.privacy.modifications.content')}
      </p>
      <h2>{t('legal.privacy.contact.title')}</h2>
      <p>{t('legal.privacy.contact.content')}
      </p>
      <p>{t('legal.privacy.effectiveDate')}
      </p>
    </Section>)
}
export default PolitiqueDeConfidentialite
